import axios from "axios";
import {
  SETTINGS_GET_PUNCH_LIST_STATUS_TYPE_LOADING,
  SETTINGS_GET_PUNCH_LIST_STATUS_TYPE,
  SETTINGS_PUNCH_LIST_STATUS_TYPE_ERROR,
  SETTINGS_ADD_PUNCH_LIST_STATUS_TYPE,
  SETTINGS_ADD_PUNCH_LIST_STATUS_TYPE_SUCCESS,
  SETTINGS_ADD_PUNCH_LIST_STATUS_TYPE_ERROR,
  SETTINGS_DELETE_PUNCH_LIST_STATUS_TYPE_SUCCESS,
  SETTINGS_PUNCH_LIST_STATUS_TYPE_CLEAR_SNACKBAR,
} from "../constants/types";
import queryString from "query-string";

// import { bulkUploadFiles } from "./documentsActions";

import { server_url } from "../constants/types";
import request from "config/api";

export const fetchPunchListStatusType = (params = {}) => {
  return (dispatch, getState) => {
    return new Promise((resolve) => {
      dispatch({
        type: SETTINGS_GET_PUNCH_LIST_STATUS_TYPE_LOADING,
        payload: {
          loading: true,
        },
      });
      const newParams = {
        PageNumber: params.page ? params.page + 1 : 1,
        PageSize: params.pageSize ? params.pageSize : 10,
      };
      const queryParams = queryString.stringify(newParams);

      request({
        url: `${server_url}/PunchListStatusType`,
        method: "GET",
      })
        .then((response) => {
          dispatch({
            type: SETTINGS_GET_PUNCH_LIST_STATUS_TYPE,
            payload: {
              punchListStatusType: response.data,
              totalCount: response.data.length,
              loading: false,
            },
          });
          resolve();
        })
        .catch((e) => {
          dispatch({
            type: SETTINGS_PUNCH_LIST_STATUS_TYPE_ERROR,
            payload: {
              status: "error",
              text: "Error occured during getting all PunchListStatusType.",
              loading: false,
              showSnackbar: true,
            },
          });
          resolve();
        });
    });
  };
};

export const addUpdatePunchListStatusType = ({
  formData,
  onSuccess,
  payload,
}) => {
  return (dispatch, getState) => {
    return new Promise((resolve) => {
      dispatch({
        type: SETTINGS_ADD_PUNCH_LIST_STATUS_TYPE,
        payload: {
          loading: true,
        },
      });

      let data = {
        ...formData,
      };

      request({
        method: formData.punchListStatusTypeId ? "PUT" : "POST",
        url: `${server_url}/PunchListStatusType${
          formData.punchListStatusTypeId
            ? `/${formData.punchListStatusTypeId}`
            : ""
        }`,
        body: { ...data, listingOrder: data.listingOrder + 1 },
      })
        .then(async (response) => {
          onSuccess();

          dispatch({
            type: SETTINGS_ADD_PUNCH_LIST_STATUS_TYPE_SUCCESS,
            payload: {
              response: response.data,
              status: "success",
              text: formData.punchListTypeId
                ? "PunchListStatusType updated Successfully"
                : "PunchListStatusType Created Successfully",
              loading: false,
              showSnackbar: true,
            },
          });
          resolve();
        })
        .catch((e) => {
          dispatch({
            type: SETTINGS_ADD_PUNCH_LIST_STATUS_TYPE_ERROR,
            payload: {
              text: "Error occurred during creating punchListStatusType data.",
              status: "error",
              loading: false,
              showSnackbar: true,
            },
          });
          resolve();
        });
    });
  };
};

export const punchListStatusTypeDelete = ({
  punchListStatusTypeId,
  pageModel,
  onSuccess = () => {},
  showSnackbar = true,
}) => {
  console.log(
    "Check the punchListStatusTypeDelete Action",
    punchListStatusTypeId
  );
  return (dispatch, getState) => {
    return new Promise((resolve) => {
      dispatch({
        type: SETTINGS_GET_PUNCH_LIST_STATUS_TYPE_LOADING,
        payload: {
          loading: true,
        },
      });
      request({
        url: `${server_url}/PunchListStatusType/${punchListStatusTypeId}`,
        method: "DELETE",
      })
        .then((response) => {
          dispatch(fetchPunchListStatusType({ ...pageModel }));
          onSuccess();

          dispatch({
            type: SETTINGS_DELETE_PUNCH_LIST_STATUS_TYPE_SUCCESS,
            payload: {
              response: response.data,
              status: "success",
              text: "punchListStatusType Deleted Successfully",
              loading: false,
              showSnackbar: true,
            },
          });

          resolve();
        })
        .catch((e) => {
          dispatch({
            type: SETTINGS_PUNCH_LIST_STATUS_TYPE_ERROR,
            payload: {
              text: "Error occurred during deleting punchListStatusType data.",
              status: "error",
              loading: false,
              showSnackbar: true,
            },
          });
          resolve();
        });
    });
  };
};

export const punchListStatusTypeClearShowSnackbar = () => {
  return (dispatch, getState) => {
    dispatch({
      type: SETTINGS_PUNCH_LIST_STATUS_TYPE_CLEAR_SNACKBAR,
    });
  };
};
